module.exports = __webpack_public_path__ + "static/media/laptop.d617772b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/laptop.png
// module id = 770
// module chunks = 0